import { Box, IconButton, Skeleton, Typography } from "@mui/material";
import React from "react";
import NavBar from "../../components/navbar/navbar";
import InfoCard from "../../components/infoCard/infocard";
import { useLocation, useNavigate } from "react-router-dom";
import CompareCard from "../../components/compareCard/CompareCard";
import FooterBar from "../../components/footerBar/footerBar";
import { Competitor, Offer } from "../home/types";
import { API_URL, sentActionLog, verify } from "../../utils/common";
import { Argument } from "./types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PlanInfo: React.FC = () => {
  const [plan, setPlan] = React.useState<Offer | undefined>(undefined);
  const [planName, setPlanName] = React.useState<string>("");
  const [zipCode, setZipCode] = React.useState<string>("");
  const [competitors, setCompetitors] = React.useState<Array<Competitor>>([]);
  const [argumentative, setArgumentative] = React.useState<Array<Argument>>([]);
  const location = useLocation();
  const navigate = useNavigate();

  const getArgumentario = React.useCallback(() => {
    if(plan){
      const token = localStorage.getItem("jwt");
      const params = new URLSearchParams({
        id_oferta: plan.id.toString(),
      });
      fetch(`${API_URL}/ofertas/argumentos?${params.toString()}`, {
        method: "GET",
        headers: {
          "Authorization": `bearer ${token}`,
          "content-type": "application/json",
        },
      })
      .then((res) => res.json())
      .then((response: Argument[]) => {
        setArgumentative(response)
      })
      .catch((err) => console.error(err));
    }
  },[plan]);

  const renderCards = () => {
    const bestCompetitor = competitors.find(
      (item) =>
        item.porcentaje === Math.max(...competitors.map((i) => i.porcentaje))
    )?.competidor;
    return argumentative.map((item) => (
      <CompareCard
        key={`compareCard-${item.id}`}
        info={item}
        isBetter={item.competidor === bestCompetitor}
      />
    ));
  };


  React.useEffect(() => {
    if(location.state?.plan){
      setPlan(location.state.plan);
      setPlanName(location.state.planName);
      setZipCode(location.state.zip);
      setCompetitors(location.state.competitors);
    } else {
      navigate('/home')
    }
  }, [location, navigate]);

  React.useEffect(() => {
    getArgumentario();
  },[plan, getArgumentario]);

  React.useEffect(() => {
    sentActionLog('Informacion Oferta', `Entro en Informacion oferta`);
  },[])

  React.useEffect(() => {
    (async () => {
      if (!["/", "/login"].includes(location.pathname)) {
        const currentToken = localStorage.getItem("jwt");
        if (currentToken) {
          const isValid = await verify(currentToken);
          if (!isValid) {
            navigate("/");
          }
        } else {
          navigate("/");
        }
      }
    })();
  }, [location.pathname, navigate]);

  return (
    <Box width={"100%"} mb={8}>
      <NavBar />
      <IconButton onClick={() => navigate('/Home', {state: {searchValue: zipCode, radioValue: location.state.radioValue }})}>
        <ArrowBackIcon />
      </IconButton>
      {plan !== undefined ? (
        <Box m={2}>
          <Typography marginBottom={2} variant="h5" fontWeight="bold">
            Tu código postal: {zipCode}
          </Typography>
          <InfoCard
            width="-webkit-fill-available"
            planName={planName}
            info={plan}
            isComplete={true}
          />
        </Box>
      ) : (
        <Skeleton animation="wave" />
      )}
      <Box m={2}>
        <Typography fontWeight="bold">
          Datos clave de la competencia
        </Typography>
        {renderCards()}
      </Box>
      <FooterBar />
    </Box>
  );
};

export default PlanInfo;
